import React, { Suspense, useEffect } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import './styles/style.scss'
import HomeLayout from './layout/HomeLayout'
import StudentLayout from './layout/StudentLayout'
import TeacherLayout from './layout/TeacherLayout'
import { useDispatch } from 'react-redux'
import { refreshToken } from './api/authService'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import AdminLayout from './layout/AdminLayout'
import VerifierLayout from './layout/VerifierLayout'
import TestCodeRedirect from './views/student/TestCodeRedirect'
import { savePendingRedirect } from './hooks/usePendingRedirect'

function App() {
  const dispatch = useDispatch()
  const token = window.localStorage.getItem('token')

  const fetchUserDetails = async () => {
    const res = await refreshToken()
    if (res?.status === 'SUCCESS') {
      window.localStorage.setItem('token', res?.token)
      dispatch({ type: 'set', res: res?.profiles || [] })
    } else {
      window.localStorage.removeItem('token')
      dispatch({ type: '', res: [] })
      if (window.location.pathname !== '/') {
        savePendingRedirect(window.location.pathname + window.location.search)
        window.location.href = '/'
      }
    }
  }
  useEffect(() => {
    if (token) {
      fetchUserDetails()
    } else {
      dispatch({ type: '', res: [] })
    }
  }, [])

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'logout-event') {
        dispatch({ type: '', res: [] })
        window.location.href = '/'
      }
    }
    window.addEventListener('storage', handleStorageChange)
    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [dispatch])

  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/student/*" name="Student" element={<StudentLayout />} />
          <Route path="/teacher/*" name="Teacher" element={<TeacherLayout />} />
          <Route path="/admin/*" name="Admin" element={<AdminLayout />} />
          <Route path="/verifier/*" name="Verifier" element={<VerifierLayout />} />
          <Route path="/login" name="Login" element={<HomeLayout />} />
          <Route path="/register" name="Register" element={<HomeLayout />} />
          <Route path="/add-profile" name="AddProfile" element={<HomeLayout />} />
          <Route path="/" name="Home" element={<HomeLayout />} />
          <Route path="/:testKey" element={<TestCodeRedirect />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
      <ToastContainer position="top-center" autoClose={5000} />
    </BrowserRouter>
  )
}

export default App
